import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import EmployeeListService from "../../services/EmployeeListService";
import IRASService from "../../services/IRASService";

const initialState = {
    formEmployeeDetails: [],
    employeeList: {},
    status: 'idle',
}

export const fetchFormEmployeeDetails = createAsyncThunk("formEmployeeDetails", async (userId) => {
    const response = await EmployeeListService.getEmployeeDetails(userId);
    return response;
  });
  
  export const deleteFormEmployeeDetails = createAsyncThunk("FormDeleteEmployeeDetails", async () => {
    return {};
  });

  export const fetchEmployeeList = createAsyncThunk("employeeList", async() => {
      const response = IRASService.getEmployeeList();
      return response; 
  })

export const SGFormsSlice = createSlice({
    name: "sgForms",
    initialState,
    reducers:{},
    extraReducers: (builder) => {
        builder
          .addCase(deleteFormEmployeeDetails.fulfilled, (state, action) => {
            state.status = "idle";
            state.formEmployeeDetails = action.payload;
          })
          .addCase(fetchFormEmployeeDetails.pending, (state) => {
            state.formEmployeeDetails = "loading";
          })
          .addCase(fetchFormEmployeeDetails.fulfilled, (state, action) => {
            state.status = "idle";
            state.formEmployeeDetails = action.payload;
          })
          .addCase(fetchEmployeeList.pending, (state) => {
            state.employeeList = "loading";
          })
          .addCase(fetchEmployeeList.fulfilled, (state, action) => {
            state.status = "idle";
            state.employeeList = action.payload;
          });
    }
})

export const selectFormEmployeeDetails = (state) => {
    return state.sgForms.formEmployeeDetails;
}

export const selectEmployeeList = (state) => {
    return state.sgForms.employeeList;
}


export default SGFormsSlice.reducer;